import React, { Component, PropTypes } from 'react';
import { browserHistory, withRouter } from 'react-router';
import { connect } from 'react-redux';
import { fetchDiscount, editDiscount, clearDiscountsErrors } from '../actions/';
import autoBind from 'react-autobind';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import EditDiscount from '../components/discounts/EditDiscount';
import Alert from '../components/home/Alert';

const propTypes = {
  dispatch: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  discounts: PropTypes.object,
  discount: PropTypes.object,
  params: PropTypes.object,
  error: PropTypes.any,
  query: PropTypes.object.isRequired,
};


class DiscountEditPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      viewRedirect: false,
      alertOpen: false,
      alertMessage: '',
      edited: false,
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillMount() {
    if (!this.props.isAuthenticated) {
      browserHistory.push('/');
    }
  }
  componentDidMount() {
    this.props.dispatch(fetchDiscount(this.props.params.id));
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.error) {
      this.setState({
        alertOpen: true,
        edited: false,
        alertMessage: `${nextProps.error.statusCode} ${nextProps.error.error} ${nextProps.error.message}`,
        error: true,
      });
    }
    if (nextProps.discounts.discount && !nextProps.error && this.state.edited) {
      this.setState({
        alertOpen: true,
        alertMessage: 'Discount edited succesfully!',
        error: false,
      });
    }
  }
  saveEditDiscount(discount) {
    const pDiscount = discount;
    delete pDiscount.uses;
    delete pDiscount.active;
    pDiscount.discountValue = (isNaN(parseInt(pDiscount.discountValue, 10))) ? 0 : pDiscount.discountValue;
    pDiscount.discountPercent = (isNaN(parseInt(pDiscount.discountPercent, 10))) ? 0 : pDiscount.discountPercent;
    this.setState({
      edited: true,
    });
    this.props.dispatch(editDiscount(pDiscount));
  }
  navigateToView(discount) {
    const pDiscount = discount;
    const nextState = this.state;
    nextState.viewRedirect = true;
    nextState.edited = true;
    this.setState(nextState);
    delete pDiscount.uses;
    delete pDiscount.active;
    this.props.dispatch(editDiscount(pDiscount));
  }
  alertHandleClose() {
    this.setState({
      alertOpen: false,
      edited: false,
      alertMessage: '',
    });
    this.props.dispatch(clearDiscountsErrors());
    if (!this.state.error) {
      if (this.state.viewRedirect === true) {
        this.setState({ viewRedirect: false });
        browserHistory.push(`/discounts/view/${this.props.discount.id}`);
      } else {
        browserHistory.push('/discounts?page=1');
      }
    }
  }
  render() {
    const authPage = {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
    };
    return (
      <div className="discount component" style={authPage}>
        {/* <h2>Edit Discount</h2> */}
        <Alert
          alertOpen={this.state.alertOpen}
          alertHandleClose={() => this.alertHandleClose()}
          alertMessage={this.state.alertMessage}
        />
        <EditDiscount
          discount={this.props.discount}
          onSave={data => this.saveEditDiscount(data)}
          onDelete={data => this.deleteDiscount(data)}
          onView={data => this.navigateToView(data)}
        />
      </div>
    );
  }
}

DiscountEditPage.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

DiscountEditPage.propTypes = propTypes;

function mapStateToProps(state, ownProps) {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    discounts: state.discounts,
    discount: state.discounts.discount,
    error: state.discounts.error,
    query: ownProps.location.query,
  };
}

export default withRouter(connect(mapStateToProps)(DiscountEditPage));



// WEBPACK FOOTER //
// ./src/containers/DiscountEditPage.js